var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{attrs:{"id":"longitude","type":"text","disabled":_vm.disabled,"formatter":_vm.formatFloat},model:{value:(_vm.floatValue),callback:function ($$v) {_vm.floatValue=$$v},expression:"floatValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }